export default __webpack_public_path__ + "static/media/1724.ea98779e.png";